import clsx from 'clsx';
import React from 'react';
import { Activation } from '../models/activation';
import { GenericTargetObjectSettings } from '../models/target-object-settings';
import { Target } from '../../activate-target/models/target';
import { TargetTypesEnum } from '../../activate-target/models/target-type';
import { HdTooltip } from '../../../components';
import { TargetConfigPopup } from '../../activate-target/TargetConfigPopup';

export function ActivationOverviewHeaderTarget({
  activation,
  target
}: {
  activation: Activation;
  target: Target;
}) {
  const isActivationTargetObjectPresent = TargetTypesEnum.GOOGLE_SHEETS !== activation.target.targetType;

  const activationTargetObjectName = (activation.targetSyncConfig as GenericTargetObjectSettings).targetObject?.displayName;

  return (
    <div className='flex-col align-items-start'>
      <span
        className={clsx(
          'text-secondary',
          !isActivationTargetObjectPresent && 'center-flex-row'
        )}
      >
        Target Object

        {!isActivationTargetObjectPresent ? (
          <TargetConfigPopup
            target={target}
            iconClasses='info-icon-sm'
          />
        ) : null}
      </span>

      {isActivationTargetObjectPresent ? (
        <div className='center-flex-row mt-1'>
          <HdTooltip title={activationTargetObjectName} enableOnTextOverflow>
            <span className='text-body-3 text-ellipsis'>
              {activationTargetObjectName}
            </span>
          </HdTooltip>

          <TargetConfigPopup
            target={target}
            iconClasses='info-icon-sm'
          />
        </div>
      ) : null}
    </div>
  );
}
